import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Package, Plus, FileText } from 'lucide-react';
import { getAuthData } from '../../utils/auth';

export const SupplierHome: React.FC = () => {
  const authData = getAuthData();

  const cards = [
    {
      title: 'Manage Inventory',
      description: 'View and manage your solar panel inventory',
      icon: Package,
      link: '/supplier/inventory',
      color: 'bg-blue-500'
    },
    {
      title: 'Request New Panel',
      description: 'Submit a request to add a new solar panel to the database',
      icon: Plus,
      link: '/supplier/request-panel',
      color: 'bg-green-500'
    },
    {
      title: 'My Requests',
      description: 'View your panel addition requests and their status',
      icon: FileText,
      link: '/supplier/requests',
      color: 'bg-purple-500'
    }
  ];

  return (
    <div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold text-gray-900">
          Welcome back, {authData?.user.full_name}
        </h1>
        <p className="text-gray-600 mt-2">{authData?.user.company}</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, index) => (
          <motion.div
            key={card.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Link to={card.link}>
              <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 cursor-pointer group">
                <div className={`${card.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <card.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{card.title}</h3>
                <p className="text-gray-600">{card.description}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
